import { zeroPad } from 'utils/zeroPad';
import moment from 'moment-timezone';

const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const nth = (d: number): string => {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formateDate = (date: Date): string => {
  return `${days[date.getDay()]}, ${date.getDate()}${nth(date.getDate())} ${
    months[date.getMonth()]
  } ${date.getFullYear()}`;
};

export const formateDateForTable = (date: Date, hasTime = true): string => {
  const lang = navigator.language || navigator.languages[0];
  const date_locale = date.toLocaleDateString(lang, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  const time_locale = date.toLocaleTimeString(lang);
  return `${date_locale}${hasTime ? ` ${time_locale}` : ''}`;
};

// eg: 29th May 12.00 UTC
export const launchPadFormatDate = (date: Date): string => {
  return `${date.getDate()}${nth(date.getDate())} ${
    months[date.getMonth()]
  } ${date.getFullYear()}`;
};

// eg 25 Jan,2024
export const formatDateDayMonYear = (date: Date): string => {
  return `${date.getDate()} ${months[date.getMonth()].slice(
    0,
    3
  )} ${date.getFullYear()}`;
};

// eg: Jan 29
export const formatDateMMDD = (date: Date): string => {
  return `${months[date.getMonth()].slice(0, 3)} ${date.getDate()}`;
};

// eg: Jan 29
export const formatDateMMDDYYYY = (date: Date): string => {
  return `${months[date.getMonth()].slice(0, 3)} ${date.getDate()} ${date.getFullYear()}`;
};

// eg: Apr 1 2024 12:00 UTC
export const formatMDYEARTimeUTC = (date: Date): string => {
  return `${months[date.getUTCMonth()].slice(
    0,
    3
  )} ${date.getUTCDate()} ${date.getUTCFullYear()} ${date.getUTCHours()}:${zeroPad(date.getUTCMinutes(), 2)} UTC`;
};

export const formatMDYEARTimeGMT = (date: Date): string => {
  const offset = -date.getTimezoneOffset() / 60;
  const timezone = `GMT${offset >= 0 ? '+' : ''}${offset}`;

  return `${months[date.getMonth()].slice(
    0,
    3
  )} ${date.getDate()} ${date.getFullYear()} ${date.getHours()}:${zeroPad(date.getMinutes(), 2)} ${timezone}`;
};

export function unixTsToDate(ts: number): Date {
  return new Date(unixTimestampToMs(ts));
}

export function unixTimestampToMs(timestamp: number): number {
  return timestamp * 1000;
}

export function msToUnixTimestamp(timestampMs: number): number {
  return Math.round(timestampMs / 1000);
}

export const formatDateWithTime = (date: Date): string => {
  const userTimeZone = moment.tz.guess();
  return moment.tz(date, userTimeZone).format('MMM D, h:mm A z');
};
